import { ComponentRef, Injectable, Type, inject } from '@angular/core';
import {
  DynamicDialogService,
  ModalComponent,
} from '@appkit4/angular-components/modal';
import { ModalData } from '@shared/abstraction/modal/modal-data';
import { ModalOptions } from '@shared/abstraction/modal/modal-options';

@Injectable({
  providedIn: 'root',
})
export class ModalService {
  private readonly dynamicDialogService = inject(DynamicDialogService);

  open<T>(
    component: Type<T>,
    options: ModalOptions,
    data?: ModalData
  ): ComponentRef<ModalComponent> {
    const resolvedModalId =
      typeof options.appModalId === 'string'
        ? options.appModalId
        : options.appModalId();

    return this.dynamicDialogService.openModal(
      component,
      {
        ...options,
        appModalId: resolvedModalId,
      },
      {
        modalId: resolvedModalId,
        ...data,
      }
    );
  }

  close(id: string, data?: JSONValue): void {
    this.dynamicDialogService.closeModal(id, data);
  }

  closeAll(): void {
    this.dynamicDialogService.closeAll();
  }
}
